<template lang="pug">
.sell-record-detail.d-flex.flex-column.h-100.scrollable
  .custom-header.d-flex.sticky-top
    CustomTab.flex-fill(
      :tabItems='tabItems'
      :tabItemsOptions='tabItemsOptions'
      v-model='selectedTab'
    )
    button.transparent-button(@click='emitClose')
      i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

  template(v-if='selectedTab === `RECORD_DETAIL`')
    Detail(
      :customer='customer'
      :sellRecord='sellRecord'
      @closeButtonClicked='emitClose'
    )
      //- @sellRecordSubmitted='emitClose'

  template(v-else-if='selectedTab === `RECORD_HISTORY`')
    History(
      :orderId='sellRecord.id'
      v-model='sellRecord.updated'
    )

</template>

<script>

import Detail from './tabs/Detail.vue';
import History from '@/components/history/dialogs/SellRecord/tabs/History.vue';

export default {
  props: {
    // customer: {
    //   default: () => ({}),
    // },
    sellRecord: {
      default: () => ({}),
    },
    updated: {
      default: true,
    },
  },
  computed: {
    customer() {
      return this.sellRecord ? this.sellRecord.customer : {};
    },
  },
  watch: {
    sellRecord(newVal) {
      this.tabItemsOptions.RECORD_HISTORY = {
        showNotificationDot: newVal.updated === true,
      };
    },
  },
  data: () => ({
    tabItems: {
      RECORD_DETAIL: 'รายละเอียดรายการ',
      RECORD_HISTORY: 'ประวัติการทำรายการ',
    },
    tabItemsOptions: {},
    selectedTab: 'RECORD_DETAIL',
  }),
  mounted() {
    this.tabItemsOptions.RECORD_HISTORY = {
      showNotificationDot: this.sellRecord.updated === true,
    };
  },
  methods: {
    emitClose() {
      this.$emit('closeButtonClicked');
    },
  },
  components: {
    Detail,
    History,
  },
};
</script>

<style lang="scss">
// .sell-record-detail {}
.custom-header {
  background: #fff;
  // padding-bottom: 8px;
}
</style>
